import Header from "../components/Header";
import { useEffect, useState } from "react";
import { FaRocket } from "react-icons/fa";
import { BsChatFill } from "react-icons/bs";

const IMAGE_OPTIONS = [
  { name: "long", src: "/architon_long.png" },
  { name: "short", src: "/architon_wide.png" },
  { name: "square", src: "/architon_square.png" },
];

export default function Architon() {
  const [imgSrc, setImgSrc] = useState(IMAGE_OPTIONS[0].src);

  useEffect(() => {
    const updateImage = () => {
      const ratio = window.innerWidth / window.innerHeight;
      if (ratio > 1.3) setImgSrc(IMAGE_OPTIONS[0].src); // 가로(long)
      else if (ratio < 0.8) setImgSrc(IMAGE_OPTIONS[1].src); // 세로(short)
      else setImgSrc(IMAGE_OPTIONS[2].src); // 정사각형(square)
    };
    updateImage();
    window.addEventListener("resize", updateImage);
    return () => window.removeEventListener("resize", updateImage);
  }, []);

  return (
    <div className="w-full min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <div className="flex-1 flex flex-col items-center justify-center relative mt-10 mb-20">
        <img
          src={imgSrc}
          alt="architon"
          className="max-w-[95vw]  object-contain rounded-xl shadow-lg"
        />
        <div className="inset-0 flex flex-col items-center justify-end pb-12 pointer-events-none mt-10">
          <div className="flex min-w-[80vw] gap-4 pointer-events-auto w-full max-w-[90vw]">
            <a
              href="https://forms.gle/ZbdExZJsx9MEawBE9"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-1 px-6 py-3 rounded-lg bg-blue-600 text-white font-bold text-lg shadow hover:bg-blue-700 transition text-center items-center justify-center gap-2"
            >
              <FaRocket />
              참가 신청
            </a>
            <a
              href="https://open.kakao.com/o/gyJDBIFh"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-1  px-6 py-3 rounded-lg bg-green-600 text-white font-bold text-lg shadow hover:bg-green-700 transition text-center items-center justify-center gap-2"
            >
              <BsChatFill />
              <span className="flex flex-col items-center">
                오픈톡방
                <span className="text-xs">[PW:cbas]</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
